import APIService from "./APIService";

const API_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT + "global-markets";

export default {
  getGlobalMarkets() {
    return APIService.get(API_END_POINT)
  }
}